import { LDReactClient } from "@launchdarkly/react-sdk";

type FeatureFlagValues = ReturnType<LDReactClient["allFlags"]>;

declare global {
  interface Window {
    /** Current LaunchDarkly flag values, for the browser console: `window.featureFlags["flag-key"]`. */
    readonly featureFlags?: FeatureFlagValues;
  }
}

/**
 * Exposes the client's flags as `window.featureFlags` for debugging from the console. A getter
 * rather than a snapshot, so it always shows the current values (after login, a studio switch or
 * a live change) without subscribing to change events, which would open a streaming connection.
 * Each read returns a copy, so editing it in the console never reaches the SDK.
 */
export const exposeFeatureFlagsOnWindow = (client: LDReactClient) => {
  Object.defineProperty(window, "featureFlags", {
    configurable: true,
    get: () => ({ ...client.allFlags() }),
  });
};
